import { CheckCircle2, Sparkles, X } from 'lucide-react';

import { useHolidayStore } from '@/store/useHolidayStore';

export function RitualCompleteModal() {
  const { showRitualComplete, setShowRitualComplete } = useHolidayStore();

  if (!showRitualComplete) return null;

  const handleClose = () => {
    setShowRitualComplete(false);
  };

  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center bg-black/80 backdrop-blur-md animate-modal-backdrop-in"
      onClick={handleClose}
    >
      <div
        className="relative bg-gradient-to-b from-green-900/95 via-emerald-900/95 to-black/95 rounded-2xl p-8 max-w-md mx-4 border-2 border-green-500/50 shadow-2xl animate-modal-backdrop-in"
        onClick={(e) => e.stopPropagation()}
        style={{
          boxShadow: '0 0 60px rgba(34, 197, 94, 0.4), 0 0 100px rgba(16, 185, 129, 0.2)',
        }}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Sparkles decoration */}
        <div className="absolute -top-6 -left-6 text-green-400 animate-pulse">
          <Sparkles className="w-12 h-12" />
        </div>
        <div className="absolute -top-6 -right-6 text-green-400 animate-pulse" style={{ animationDelay: '0.5s' }}>
          <Sparkles className="w-12 h-12" />
        </div>

        {/* Content */}
        <div className="text-center text-white font-outfit">
          {/* Success icon */}
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="w-24 h-24 rounded-full bg-green-500/20 flex items-center justify-center">
                <CheckCircle2 className="w-16 h-16 text-green-400" />
              </div>
              <div className="absolute inset-0 animate-ping opacity-30">
                <div className="w-24 h-24 rounded-full bg-green-400" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-3xl font-bold text-transparent bg-clip-text mb-3 bg-gradient-to-r from-green-400 via-green-300 to-green-400">
            Ritual Complete!
          </h2>

          <p className="text-lg text-green-200 mb-6">
            You've successfully joined the holiday campaign!
          </p>

          {/* Info box */}
          <div className="bg-black/40 rounded-xl p-4 mb-6">
            <p className="text-green-300 text-sm">
              Your participation has been recorded. Stay tuned for rewards and announcements!
            </p>
          </div>

          {/* Action button */}
          <button
            onClick={handleClose}
            className="w-full py-4 px-6 rounded-xl font-bold text-black transition-all transform hover:scale-105 bg-gradient-to-r from-green-500 via-green-300 to-green-500"
          >
            Awesome!
          </button>
        </div>
      </div>
    </div>
  );
}
